<script setup lang="ts">
import { storeToRefs } from "pinia";
import ProgressBar from "primevue/progressbar";

import { useLoadingStore } from "@/stores/loading";

const LoadingStore = useLoadingStore();
const { isLoading } = storeToRefs(LoadingStore);
</script>

<template>
  <ProgressBar v-show="isLoading" class="progress-bar" mode="indeterminate" :showValue="false" />
  <div v-show="!isLoading" class="bf-background-dark h-[3px] min-h-[3px]" />
</template>

<style lang="postcss" scoped>
.progress-bar {
  height: 3px;
}
</style>
